/* This file is auto-generated, see apps/apis/file_v1/types.py. */

import { Meta } from "./Core";

import { Contact } from "./User";

import { PaymentMethod } from "./Cart";

export enum InterventionStatus {
  delivery_scheduled = "delivery_scheduled",
  return_scheduled = "return_scheduled",
}

export enum QuoteStatus {
  waiting_validation = "waiting for validation",
  processing = "being processed",
  modification_requested = "modification requested",
  accepted = "accepted",
  declined = "cancelled/rejected",
}

export enum InvoiceType {
  invoice = 1,
  credit_note = 2,
}

export enum TaskAction {
  end_of_rental_request = 1,
  end_of_rental_cancellation_request = 2,
  rental_prolongation_request = 3,
  offer_validation_request = 4,
  equipment_move_request = 5,
  temporary_closed_site_info = 6,
  quote_request = 7,
  invoice_complaint_request = 8,
  equipment_moved_info = 9,
  visit_note_updated = 10,
  offer_modification_request = 11,
  offer_cancellation_request = 12,
  intervention_recall_request = 13,
  return_of_satisfaction_survey = 14,
  update_customer_order_information = 15,
  update_insurance_certificate = 16,
}

export enum FileType {
  construction_site = 1,
  event = 2,
  deterioration = 3,
  other = 4,
  pro_forma = 5,
  new = 6,
  discovery = 7,
  prestation_de_service = 8,
  city = 9,
  agriculture = 10,
  loc_mat_cuisine = 11,
  industrie = 12,
  happee = 13,
  second_hand = 14,
}

export enum SignatureRequestStatus {
  ongoing = "ongoing",
  done = "done",
  declined = "declined",
  expired = "expired",
  canceled = "canceled",
  approval = "approval",
  rejected = "rejected",
}

export enum Market {
  building = "building",
  event = "event",
}

export type ScheduleWeek = { week: number };

export type ScheduleDateRange = { from: string; to: string };

export type Status = { id: number; label: string; isCustomerFault: boolean };

export type Schedule = null | ScheduleDateRange | ScheduleWeek;

export type ProfileInterventionStats = {
  total: number;
  incoming: number;
  success: number;
  enygeaFail: number;
  customerFail: number;
  period: ScheduleDateRange;
};

export type ProfileFileCounters = {
  total: number;
  inProgress: number;
  hasQuotes: number;
  closed: number;
  done: number;
};

export type ProfileInvoiceCounters = {
  trackingEnabled: boolean;
  total: number;
  overdue: number;
  pending: number;
  creditNotes: number;
  hasClaims: number;
  history: number;
};

export type ProfileQuoteCounters = { active: number; new: number };

export type OrderCounter = { pending: number };

export type CustomerCounter = { withReservationEnabled: number };

export type CustomerOrderCounter = { expired: number };

export type ProfileCounters = {
  files: ProfileFileCounters;
  quotes: ProfileQuoteCounters;
  invoices: ProfileInvoiceCounters;
  interventions: number;
  orders: OrderCounter;
  customers: CustomerCounter;
  customerOrders: CustomerOrderCounter;
};

export type OpeningTime = {
  dayNumber: 1 | 2 | 3 | 4 | 5 | 6 | 7;
  isClosed: boolean;
  amTimeFrom: null | string;
  amTimeTo: null | string;
  pmTimeFrom: null | string;
  pmTimeTo: null | string;
};

export type Document = { downloadUrl?: string };

export interface CloseStatus {
  from: string;
  until: string;
  because: string;
}

export interface BaseFile {
  id: number;
  companyId: number;
  type: FileType;
  startDate: string;
  endOfRental: boolean;
  inProgress: boolean;
  orderMandatory: boolean;
  statusDetail: string;
  interventionStatus: InterventionStatus[];
  userRoles: any;
  newQuotes: number;
  closeStatus: null | CloseStatus;
  equipmentCategories: string[];
  currency: string;
  market: Market | null;
  closedDays?: CloseStatus[];
  nextClosedPeriod?: null | { from: string; until: string };
  currentOrder: null | Order;
  customer: number;
}

export interface BaseIntervention {
  id: number;
  driver: string;
  type: number;
  status: Status;
  result: number;
  asked: string;
  planned: string;
  done: string;
  isActive: boolean;
  plannedRange: Schedule;
  isCancelable: boolean;
  isRecallable: boolean;
  pictures?: string[];
}

export interface File extends BaseFile {
  latitude: number;
  longitude: number;
  visitDelay: number;
  visitNote: string;
  deliveryPlace: string;
  deliveryAddress: string;
  deliveryExact: string;
  returnPlace: string;
  returnAddress: string;
  returnExact: string;
  customerCode: string;
  reference: string;
}

export interface Agency {
  id: number;
  name: string;
  displayName: string;
  street: string;
  zipcode: string;
  phone: string;
  fax: string;
  color: number;
  email: string;
  latitude: number;
  longitude: number;
  image: string;
  logo: string;
  htmlText: string;
  openingTime: OpeningTime[];
  contacts: Contact[];
  activeFiles?: number;
  closedDays: any;
  tosUrl: string;
  privacyUrl: string;
  isForUser: boolean;
  isVisibleOnMap: boolean;
}

export interface ConstructionSite {
  version: number;
  latitude: number;
  longitude: number;
  visitDelay: number;
  visitNote: string;
  deliveryPlace: string;
  deliveryAddress: string;
  deliveryExact: string;
  returnPlace: string;
  returnAddress: string;
  returnExact: string;
  customerCode: string;
  reference: string;
}

export interface FileAction {
  id: number;
  file: number;
  user: number;
  type: any;
  taskId?: string;
}

export interface Invoice extends Document {
  id: number;
  date: string;
  dueDate: string;
  isOverdue: boolean;
  type: InvoiceType;
  sumHtva: number;
  sumTtc: number;
  payed: boolean;
  canBePayed: boolean;
  payment: { enabled?: boolean; means: Array<{ name: PaymentMethod }> };
  parentInvoice: null | number;
  lines: any;
  claimsCount: number;
  currency: string;
  fileIds: number[];
  isTrackingEnabled: boolean;
  relatedFileReferences: string[];
  isBalance: boolean;
  isDeposit: boolean;
  pendingPayment: boolean;
}

export interface InvoiceSummary extends Document {
  id: number;
  date: string;
  sumHtva: number;
  sumTtc: number;
}

export interface Order extends Document {
  id: number;
  fileId: number;
  reference: string;
  validUntil: string;
  isExpired: boolean;
  processing: boolean;
  isGoingToExpire: boolean;
}

export interface Quote extends Document {
  id: number;
  createdAt: string;
  status: any;
  fileId: number;
}

export interface QuoteAction {
  comment: string;
}

export interface Intervention extends BaseIntervention {
  file: Pick<File, "id" | "companyId" | "deliveryPlace" | "deliveryAddress" | "reference">;
}

export interface FileWithDetails extends File, BaseFile {
  meta?: Meta;
  contacts: Contact[];
  equipments: any;
  interventions: Pick<
    BaseIntervention,
    "id" | "driver" | "type" | "status" | "result" | "asked" | "planned" | "plannedRange" | "done" | "isActive"
  >[];
  orders?: Order[];
  lastKnownPosition: string;
  invoices?: Invoice[];
  quotes?: Quote[];
  actions?: FileAction[];
}

export interface FileProfile {
  meta?: Meta;
  counters: ProfileCounters;
  hasCartPermission: boolean;
  hasInvoicePermission: boolean;
  interventionsStats: ProfileInterventionStats;
  isProfessional: boolean;
  isIndividual: boolean;
  markets: Market[];
  onboarding?: any;
  hasExpiredInsuranceCertificates: boolean;
  hasExpiringInsuranceCertificates: boolean;
  hasBlockedCustomers: boolean;
}

export interface SignatureRequest {
  quoteId: number;
  downloadUrl: string;
  createdAt: string;
  quoteStatus: any;
  fileId: string;
  requestStatus: SignatureRequestStatus;
  link: string;
}
